import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { giftCategoryIdAtom } from '../atoms/giftItemAtoms';

function useGiftCategories() {
    const { data, status } = useQuery(queries.giftCategory.list());
    const { pop } = useFlow();
    const toast = useToast();
    const setGiftCategoryId = useSetAtom(giftCategoryIdAtom);
    const { t } = useTranslation('gift');
    useEffect(() => {
        if (status === 'error') {
            toast.error(t('category.loadError'));
            pop();
        }
    }, [toast, pop, status, t]);
    useEffect(() => {
        if (data && data.length > 0) {
            setGiftCategoryId(data[0].id);
        }
    }, [setGiftCategoryId, data]);
    return data;
}

export default useGiftCategories;
